import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccessibilityCallout, LazyAccordionWithImages, LazyAccordion, LazyAdditionalExhibitions, LazyAlignedFiftyFifty, LazyAnnouncement, LazyArchitectureEncyclopediaCallout, LazyArchitectureEncyclopedia, LazyAwardsMarquee, LazyAwards, LazyBoatAmenities, LazyBuildingsCarousel, LazyBuildingsFilter, LazyBuildingsDetail, LazyBuildingsHeader, LazyButtonBlock, LazyCalendarGridWithFilters, LazyCarouselWithIconCards, LazyCenterDetailsAdmission, LazyCenterDetailsCenterMap, LazyCenterDetailsLocationHours, LazyCenterDetailsParent, LazyCityToursManual, LazyCityToursCard, LazyCityToursDetails, LazyCityToursHeader, LazyCityTours, LazyCityToursPricing, LazyCityToursTags, LazyCityToursThings, LazyContactUsBlock, LazyContainerFiftyFifty, LazyContributorsCarousel, LazyCustomCode, LazyDebug, LazyDesignStore, LazyDocentProcess, LazyDocentsDetailList, LazyEncyclopediaArticleDetailHeader, LazyEventsProgramsThreeUp, LazyExhibitionCards, LazyExhibitionHero, LazyExhibitionsGrid, LazyFactCarousel, LazyFavoriteBuildings, LazyFeaturedContent, LazyFormsAirtable, LazyFormsFillout, LazyFourUpStaggered, LazyFullWidthFiftyFiftyWithRedBanner, LazyFullWidthFiftyFifty, LazyFullWidthImageWithText, LazyHeadline, LazyHero, LazyHorizontalCards, LazyIconGrid, LazyImageCarouselWithCaptions, LazyInternalPageHero, LazyLargeIconsBlock, LazyMarquee, LazyMemberBenefits, LazyMembershipOptions, LazyMissionVision, LazyNewsletterBlock, LazyOpenHouseChicago, LazyPastExhibitionsGrid, LazyProgramDetailHeader, LazyProgramsEventsFilterWithGrid, LazyPullQuote, LazyRelatedTeamMembers, LazyResourcesCarousel, LazyResourcesGrid, LazySponsorsMediaPartners, LazyStatsFiftyFifty, LazyStoriesGrid, LazyStoriesThreeUp, LazySubNavParentBlock, LazySubNavQuickLinks, LazyTeamMemberDetailHeader, LazyTeamMembersFilterGrid, LazyTestimonialsCarousel, LazyTextOnlyHero, LazyText, LazyThreeCardsWithLinks, LazyThreeOrFourUpCardsWithLinks, LazyToursFilter, LazyTwoCards, LazyTwoUpWithText, LazyUpcomingEventsTwoUp, LazyVideo, LazyVideoscript, LazyArrowDown, LazyArrowLeft, LazyArrowRightWithCircle, LazyArrowRight, LazyArrowTopRight, LazyCSmallBug, LazyCalendar, LazyCart, LazyChevronDown, LazyChevronLeft, LazyChevronRight, LazyChevronUp, LazyClock, LazyDragButton, LazyGrid, LazyLogoLong, LazyLogo, LazyMinus, LazyPlay, LazyPlus, LazyQuote, LazySearch, LazySocialsFacebook, LazySocialsInstagram, LazySocialsLinkedin, LazySocialsPinterest, LazySocialsThreads, LazySocialsTiktok, LazySocialsX, LazySocialsYoutube, LazyTooltip, LazyX } from '#components'
const lazyGlobalComponents = [
  ["AccessibilityCallout", LazyAccessibilityCallout],
["AccordionWithImages", LazyAccordionWithImages],
["Accordion", LazyAccordion],
["AdditionalExhibitions", LazyAdditionalExhibitions],
["AlignedFiftyFifty", LazyAlignedFiftyFifty],
["Announcement", LazyAnnouncement],
["ArchitectureEncyclopediaCallout", LazyArchitectureEncyclopediaCallout],
["ArchitectureEncyclopedia", LazyArchitectureEncyclopedia],
["AwardsMarquee", LazyAwardsMarquee],
["Awards", LazyAwards],
["BoatAmenities", LazyBoatAmenities],
["BuildingsCarousel", LazyBuildingsCarousel],
["BuildingsFilter", LazyBuildingsFilter],
["BuildingsDetail", LazyBuildingsDetail],
["BuildingsHeader", LazyBuildingsHeader],
["ButtonBlock", LazyButtonBlock],
["CalendarGridWithFilters", LazyCalendarGridWithFilters],
["CarouselWithIconCards", LazyCarouselWithIconCards],
["CenterDetailsAdmission", LazyCenterDetailsAdmission],
["CenterDetailsCenterMap", LazyCenterDetailsCenterMap],
["CenterDetailsLocationHours", LazyCenterDetailsLocationHours],
["CenterDetailsParent", LazyCenterDetailsParent],
["CityToursManual", LazyCityToursManual],
["CityToursCard", LazyCityToursCard],
["CityToursDetails", LazyCityToursDetails],
["CityToursHeader", LazyCityToursHeader],
["CityTours", LazyCityTours],
["CityToursPricing", LazyCityToursPricing],
["CityToursTags", LazyCityToursTags],
["CityToursThings", LazyCityToursThings],
["ContactUsBlock", LazyContactUsBlock],
["ContainerFiftyFifty", LazyContainerFiftyFifty],
["ContributorsCarousel", LazyContributorsCarousel],
["CustomCode", LazyCustomCode],
["Debug", LazyDebug],
["DesignStore", LazyDesignStore],
["DocentProcess", LazyDocentProcess],
["DocentsDetailList", LazyDocentsDetailList],
["EncyclopediaArticleDetailHeader", LazyEncyclopediaArticleDetailHeader],
["EventsProgramsThreeUp", LazyEventsProgramsThreeUp],
["ExhibitionCards", LazyExhibitionCards],
["ExhibitionHero", LazyExhibitionHero],
["ExhibitionsGrid", LazyExhibitionsGrid],
["FactCarousel", LazyFactCarousel],
["FavoriteBuildings", LazyFavoriteBuildings],
["FeaturedContent", LazyFeaturedContent],
["FormsAirtable", LazyFormsAirtable],
["FormsFillout", LazyFormsFillout],
["FourUpStaggered", LazyFourUpStaggered],
["FullWidthFiftyFiftyWithRedBanner", LazyFullWidthFiftyFiftyWithRedBanner],
["FullWidthFiftyFifty", LazyFullWidthFiftyFifty],
["FullWidthImageWithText", LazyFullWidthImageWithText],
["Headline", LazyHeadline],
["Hero", LazyHero],
["HorizontalCards", LazyHorizontalCards],
["IconGrid", LazyIconGrid],
["ImageCarouselWithCaptions", LazyImageCarouselWithCaptions],
["InternalPageHero", LazyInternalPageHero],
["LargeIconsBlock", LazyLargeIconsBlock],
["Marquee", LazyMarquee],
["MemberBenefits", LazyMemberBenefits],
["MembershipOptions", LazyMembershipOptions],
["MissionVision", LazyMissionVision],
["NewsletterBlock", LazyNewsletterBlock],
["OpenHouseChicago", LazyOpenHouseChicago],
["PastExhibitionsGrid", LazyPastExhibitionsGrid],
["ProgramDetailHeader", LazyProgramDetailHeader],
["ProgramsEventsFilterWithGrid", LazyProgramsEventsFilterWithGrid],
["PullQuote", LazyPullQuote],
["RelatedTeamMembers", LazyRelatedTeamMembers],
["ResourcesCarousel", LazyResourcesCarousel],
["ResourcesGrid", LazyResourcesGrid],
["SponsorsMediaPartners", LazySponsorsMediaPartners],
["StatsFiftyFifty", LazyStatsFiftyFifty],
["StoriesGrid", LazyStoriesGrid],
["StoriesThreeUp", LazyStoriesThreeUp],
["SubNavParentBlock", LazySubNavParentBlock],
["SubNavQuickLinks", LazySubNavQuickLinks],
["TeamMemberDetailHeader", LazyTeamMemberDetailHeader],
["TeamMembersFilterGrid", LazyTeamMembersFilterGrid],
["TestimonialsCarousel", LazyTestimonialsCarousel],
["TextOnlyHero", LazyTextOnlyHero],
["Text", LazyText],
["ThreeCardsWithLinks", LazyThreeCardsWithLinks],
["ThreeOrFourUpCardsWithLinks", LazyThreeOrFourUpCardsWithLinks],
["ToursFilter", LazyToursFilter],
["TwoCards", LazyTwoCards],
["TwoUpWithText", LazyTwoUpWithText],
["UpcomingEventsTwoUp", LazyUpcomingEventsTwoUp],
["Video", LazyVideo],
["Videoscript", LazyVideoscript],
["ArrowDown", LazyArrowDown],
["ArrowLeft", LazyArrowLeft],
["ArrowRightWithCircle", LazyArrowRightWithCircle],
["ArrowRight", LazyArrowRight],
["ArrowTopRight", LazyArrowTopRight],
["CSmallBug", LazyCSmallBug],
["Calendar", LazyCalendar],
["Cart", LazyCart],
["ChevronDown", LazyChevronDown],
["ChevronLeft", LazyChevronLeft],
["ChevronRight", LazyChevronRight],
["ChevronUp", LazyChevronUp],
["Clock", LazyClock],
["DragButton", LazyDragButton],
["Grid", LazyGrid],
["LogoLong", LazyLogoLong],
["Logo", LazyLogo],
["Minus", LazyMinus],
["Play", LazyPlay],
["Plus", LazyPlus],
["Quote", LazyQuote],
["Search", LazySearch],
["SocialsFacebook", LazySocialsFacebook],
["SocialsInstagram", LazySocialsInstagram],
["SocialsLinkedin", LazySocialsLinkedin],
["SocialsPinterest", LazySocialsPinterest],
["SocialsThreads", LazySocialsThreads],
["SocialsTiktok", LazySocialsTiktok],
["SocialsX", LazySocialsX],
["SocialsYoutube", LazySocialsYoutube],
["Tooltip", LazyTooltip],
["X", LazyX],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
